export type DomainField = 'domain' | 'shopDomain';

export class DomainRecord {
    id: string = '';
    name: string = '';
    companyId: string = '';
    companyName?: string = '';
    url: string = '';
    field: DomainField = 'domain';
    recordId?: string;
    content?: string;
    type?: string;

    constructor(raw?: Partial<DomainRecord>) {
        if (!raw) return;
        Object.assign(this, raw);
    }
}
